import DesignSwitcher from '../components/DesignSwitcher.jsx';

// Home route (/): the ten landing-page designs behind the design switcher.
export default function HomePage() {
  return <DesignSwitcher />;
}
